export default "__VITE_ASSET__DmYPYU5s__"